import { render, staticRenderFns } from "./SfAccordion.vue?vue&type=template&id=5d27cead"
import script from "./SfAccordion.vue?vue&type=script&lang=js"
export * from "./SfAccordion.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfAccordion.vue?vue&type=style&index=0&id=5d27cead&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "55f46752"
  
)

export default component.exports